import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { mappingResultError, Result, UseCase } from '@digibricks/domains';
import { NoneValue } from '../../../domain';
export var DELETE_HEADING_USE_CASE = 'DELETE_HEADING_USE_CASE';
export var DeleteHeadingUseCase = /*#__PURE__*/function (_UseCase) {
  _inherits(DeleteHeadingUseCase, _UseCase);

  var _super = _createSuper(DeleteHeadingUseCase);

  function DeleteHeadingUseCase(formRepository) {
    var _this;

    _classCallCheck(this, DeleteHeadingUseCase);

    _this = _super.call(this);
    _this.formRepository = formRepository;
    return _this;
  }

  _createClass(DeleteHeadingUseCase, [{
    key: "buildUseCase",
    value: function () {
      var _buildUseCase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input) {
        var heading, headings, _input$isSkipApiCall, isSkipApiCall, newHeadings, previousHeading, nextHeading, resultOrError;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                heading = input.heading, headings = input.headings, _input$isSkipApiCall = input.isSkipApiCall, isSkipApiCall = _input$isSkipApiCall === void 0 ? false : _input$isSkipApiCall;
                newHeadings = _toConsumableArray(headings);
                previousHeading = newHeadings.find(function (h) {
                  return h.nextHeadingId === heading.id.toString();
                });

                if (previousHeading) {
                  previousHeading.updateNextHeadingId(heading.nextHeadingId);

                  if (previousHeading.nextQuestionId === NoneValue && heading.nextQuestionId !== NoneValue) {
                    previousHeading.updateNextQuestionId(heading.nextQuestionId);
                  }
                }

                nextHeading = newHeadings.find(function (h) {
                  return h.previousHeadingId === heading.id.toString();
                });

                if (nextHeading) {
                  nextHeading.updatePreviousHeadingId(heading.previousHeadingId);

                  if (nextHeading.previousQuestionId === NoneValue && heading.previousQuestionId !== NoneValue) {
                    nextHeading.updatePreviousQuestionId(heading.previousQuestionId);
                  }
                }

                if (isSkipApiCall) {
                  _context.next = 12;
                  break;
                }

                _context.next = 9;
                return this.formRepository.deleteHeading(heading);

              case 9:
                resultOrError = _context.sent;

                if (!resultOrError.isFailure) {
                  _context.next = 12;
                  break;
                }

                return _context.abrupt("return", mappingResultError(resultOrError));

              case 12:
                newHeadings = newHeadings.filter(function (h) {
                  return h.id.toString() !== heading.id.toString();
                });
                return _context.abrupt("return", Result.ok({
                  deletedHeading: heading,
                  newHeadings: newHeadings
                }));

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function buildUseCase(_x) {
        return _buildUseCase.apply(this, arguments);
      }

      return buildUseCase;
    }()
  }]);

  return DeleteHeadingUseCase;
}(UseCase);